import React from 'react';
import { SCREENS } from '../../../constants/screens';
import HeaderTitle from '../../containers/Headers/components/HeaderTitle/HeaderTitle';
import Headers from '../../containers/Headers/Headers';
import ScrollableBlock from '../../containers/ScrollableBlock/ScrollableBlock';
import PlatesSection from 'src/view/components/PlatesSection/PlatesSection';
import Plate from 'src/view/components/Plate/Plate';
import { hasRole } from '~/utils/helpers';
import { USER_ROLES } from '~/constants/user';

const ReportsScreen = (): JSX.Element => {
  return (
    <div className="d-flex flex-column full-width">
      <Headers>
        <HeaderTitle title="reports" />
      </Headers>
      <ScrollableBlock className="d-flex flex-column flex-grow-1" scrollClassName="pt-6 gap-30" showScrollbar scrollbarSize="normal">
        <PlatesSection title="sales_period">
          <Plate title="sales_per_hours" description="sales_per_hour_tip" path={SCREENS.HOURS_SALES()} />
          <Plate title="daily_weekly_sales" description="daily_weekly_sales_tip" path={SCREENS.DAY_WEEK_SALES()} />
          <Plate title="monthly_sales" description="monthly_sales_tip" path={SCREENS.MONTH_YEAR_SALES()} />
        </PlatesSection>
        <PlatesSection title="sales_location">
          <Plate title="area_sales" description="area_sales_tip" path={SCREENS.AREA_SALES()} />
          <Plate title="branch_sales" description="branch_sales_tip" path={SCREENS.BRANCH_SALES()} />
        </PlatesSection>
        <PlatesSection title="sales_details">
          <Plate title="agent_sales" description="agent_sales_tip" path={SCREENS.CALL_CENTER_AGENT_SALES()} />
          <Plate title="item_sales" description="item_sales_tip" path={SCREENS.ITEM_SALES()} />
          <Plate title="sales_per_payment_method" description="sales_per_payment_method_tip" path={SCREENS.PAYMENT_METHOD_SALES()} />
          <Plate title="ordering_channel_sales" description="ordering_channel_sales_tip" path={SCREENS.ORDERING_CHANNEL_SALES()} />
          <Plate title="combo_sales_report_button_name" description="combo_sales_report_button_description" path={SCREENS.COMBO_SALES()} />
        </PlatesSection>
        <PlatesSection title="logs_hearder">
          {!hasRole([USER_ROLES.FRANCHISEE, USER_ROLES.ACCOUNTING]) ? (
            <>
              <Plate title="wallet_log" description="data_on_wallet" path={SCREENS.WALLET_TRANSACTION_LOG()} />
              <Plate title="branch_log" description="data_on_branch_transactions" path={SCREENS.BRANCHES_LOG()} />
              <Plate
                title="reports_view_promocode_log_button"
                description="reports_view_promocode_log_button_description"
                path={SCREENS.PROMOCODE_LOG()}
              />
            </>
          ) : null}
          <Plate title="reports_refund_journal_btn_title" description="reports_refund_journal_btn_detailed_info" path={SCREENS.REFUND_LOG()} />
          <Plate title="wh_log_bubble_title" description="wh_log_bubble_bodytext" path={SCREENS.BRANCHES_WORKING_HOURS_LOG('all')} />
        </PlatesSection>
      </ScrollableBlock>
    </div>
  );
};

export default ReportsScreen;
